module.exports = __webpack_public_path__ + "img/newborn.864bf54f.jpg";